import { defineStore } from 'pinia';
import { MinuAmetnik } from '@/models/Ametnik';

export type AmetnikState = {
  ametnik: MinuAmetnik ;
  ametnikSaadud: boolean;
};

export const useAmetnikStore = defineStore('ametnikStore', {
  state: () => {
    return {
      ametnik: new MinuAmetnik(),
      ametnikSaadud: false,
    } as AmetnikState;
  },
  persist: { storage: sessionStorage },
  actions: {
    satiAmetnik(dto: MinuAmetnik) {
      this.ametnik = { ...dto };
      this.ametnikSaadud = true;
    },
    eemaldaAmetnik() {
      this.ametnik = new MinuAmetnik();
      this.ametnikSaadud = false;
    }
  },
});
